import { AddGlobalAdminModal} from "./AddGlobalAdminModal";

export default AddGlobalAdminModal;
